import { formatDate } from "@angular/common";
import {
  Component,
  Inject,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NbMenuService } from "@nebular/theme";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import {
  NgxQrcodeElementTypes,
  NgxQrcodeErrorCorrectionLevels,
} from "@techiediaries/ngx-qrcode";
import { LocalDataSource } from "angular2-smart-table";
import { AuthService } from "../../services/auth/auth.service";
import {
  EventService,
  IEventTransaction,
  IEventUser,
  IEventUserCategory,
} from "../../services/database/event/event.service";
import { EventBartenderService } from "../../services/database/event/eventbartender.service";
import { EventManagerService } from "../../services/database/event/eventmanager.service";
import { EventtokengeneratorService } from "../../services/database/event/eventtokengenerator.service";
import { UserService } from "../../services/database/user/user.service";
import { IUser } from "../../services/model/user.model";
import { SearchService } from "../../services/search/search.service";
import { ToastrService } from "../../services/toastr/toastr.service";
import { StorageService } from "../../services/storage/storage.service";
import { v4 as uuidv4 } from "uuid";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { ImportService } from "../../services/import/import.service";
import { InvitemailService } from "../../services/invitemail/invitemail.service";
import { take } from "rxjs/operators";
import { FriendService } from "../../services/friend/friend.service";
import Swal from "sweetalert2";
import { NotificationService } from "../../services/database/notification/notification.service";
import writeXlsxFile from "write-excel-file";

type ImportInfo = {
  url: string;
  email: string;
  amount: number;
};

@Component({
  selector: "ngx-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"],
})
export class UsersComponent implements OnInit {
  @ViewChildren(SwalComponent) swals: QueryList<SwalComponent>;
  public mySwal: SwalComponent;
  public mySwalNameInput: SwalComponent;
  public mySwalAmountInput: SwalComponent;
  public mySwalMessageInput: SwalComponent;
  searchValue: string;
  eventId: string;
  user: IEventUser;
  users: any[];
  userFound = false;
  showReset = true;
  source: LocalDataSource = new LocalDataSource();
  categories: IEventUserCategory[];
  selectedCategories = [];
  selectedUsers = [];
  filteredUsers: any[];
  myNameForm: FormGroup;
  selectedAmount: number;
  userId: string;
  exportUsersURL: string;
  exporting = false;
  uploadFile: string | ArrayBuffer;
  excelFileSelected: boolean;
  amountUploaded: number = -1;
  couponsInInvite: number = 0;
  message = "";
  selectedTransactionKey = "";
  order = [];
  cachedCategories = [];
  generatedURLs: Array<ImportInfo> = [];

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      transactionId: {
        title: "id",
        type: "string",
      },
      timestamp: {
        title: "Date",
        type: "string",
      },
      type: {
        title: "Type",
        type: "string",
      },
      description: {
        title: "Description",
        type: "string",
      },
      amount: {
        title: "Amount",
        type: "string",
      },
      relatedUserName: {
        title: "User",
        type: "string",
      },
    },
  };
  context = [
    { title: "Change name", data: "changeName" },
    { title: "Send message", data: "sendMessage" },
    { title: "Send tokens", data: "sendTokens" },
    { title: "Set tokens to 0", data: "resetTokens" },
    { title: "Make bartender", data: "makeBartender" },
    { title: "Make event manager", data: "makeEventManager" },
    { title: "Make token dispenser", data: "makeTokenDispenser" },
    { title: "Delete from event/club", data: "deleteFromEvent" },
  ];
  qrCodeType = NgxQrcodeElementTypes.URL;
  qrCodeCorrectionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  constructor(
    private searchService: SearchService,
    private eventService: EventService,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private nbMenuService: NbMenuService,
    private bartenderService: EventBartenderService,
    private managerservice: EventManagerService,
    private tokengeneratorService: EventtokengeneratorService,
    private userService: UserService,
    private authService: AuthService,
    private storageService: StorageService,
    private afFunctions: AngularFireFunctions,
    private importService: ImportService,
    private invitemailService: InvitemailService,
    private friendService: FriendService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get("eventId");
    this.eventService
      .getEventUserCategories(this.eventId)
      .subscribe((categories) => {
        this.categories = categories;
        this.cachedCategories = [];
        this.categories.forEach((category) => {
          this.cachedCategories[category.key] = category.description;
        });
      });
    this.authService.get().subscribe((user) => {
      this.userId = user.uid;
    });
    this.nbMenuService.onItemClick().subscribe((observer) => {
      switch (observer.item.data) {
        case "changeName":
          this.changeName(observer.tag);
          break;
        case "changeCategory":
          this.changeCategory(observer.tag);
          break;
        case "sendTokens":
          this.sendTokens(observer.tag);
          break;
        case "sendMessage":
          this.sendMessageToUser(observer.tag);
          break;
        case "resetTokens":
          this.resetTokens(observer.tag);
          break;
        case "makeBartender":
          this.makeBartender(observer.tag);
          break;
        case "makeEventManager":
          this.makeEventManager(observer.tag);
          break;
        case "makeTokenDispenser":
          this.makeTokenDispenser(observer.tag);
          break;
        case "deleteFromEvent":
          this.deleteFromEvent(observer.tag);
          break;
        case "generateNewQRCode":
          this.newQRCode(observer.tag);
          break;
      }
    });
  }

  ngAfterViewInit() {
    this.swals.forEach((swal, index) => {
      if (index == 0) {
        this.mySwal = swal;
      } else if (index == 1) {
        this.mySwalNameInput = swal;
      } else if (index == 2) {
        this.mySwalAmountInput = swal;
      } else if (index == 3) {
        this.mySwalMessageInput = swal;
      }
    });
  }

  clearLocals() {
    this.message = "";
    this.selectedAmount = 0;
    this.mySwalAmountInput.title = "Enter amount";
    this.mySwalMessageInput.title = "Enter message";
  }

  async changeName(id: string) {
    this.clearLocals();
    this.mySwalMessageInput.title = "Enter name";
    const { isConfirmed } = await this.mySwalMessageInput.fire();
    if (isConfirmed) {
      this.eventService
        .updateEventUser(this.eventId, id, this.message)
        .then(() => {
          this.toastrService.show(
            "Success",
            "Successfully updated user",
            "success"
          );
        })
        .catch((error) => {
          this.toastrService.show("Error", error, "danger");
        });
    }
  }
  changeCategory(id: string) {
    //TODO
    console.log("changeCategory");
  }
  deleteCategory(id: string) {
    // make sure to delete category entries for users!
    return this.eventService
      .deleteUserCategory(this.eventId, id)
      .then(() => {
        this.toastrService.show(
          "Success",
          "Successfully deleted category",
          "success"
        );
      })
      .catch((error) => {
        this.toastrService.show("Error", error, "danger");
      });
  }
  async sendTokens(toUserId: string) {
    this.sendTokensToSelectedUsers(toUserId);
  }
  async resetTokens(id: string) {
    this.clearLocals();
    this.mySwal.title = "Confirm";
    this.mySwal.text =
      "Are you sure you want to make reset the tokens for this user?";
    const { isConfirmed } = await this.mySwal.fire();
    if (isConfirmed) {
      this.resetCoupons();
    }
  }

  async addUser(eventId: string, userId: string) {
    this.mySwal.title = "Confirm";
    this.mySwal.text =
      "This user is not part of your event, do you want to add the user?";
    const { isConfirmed } = await this.mySwal.fire();
    if (isConfirmed) {
      await this.eventService.addEventUser(eventId, userId);
    }
  }

  async makeBartender(id: string) {
    this.clearLocals();
    this.mySwal.title = "Confirm";
    this.mySwal.text = "Are you sure you want to make this user bartender?";
    const { isConfirmed } = await this.mySwal.fire();
    if (isConfirmed) {
      this.bartenderService
        .addBartender({
          event_id: this.eventId,
          user_id: id,
        })
        .then(() => {
          this.toastrService.show(
            "Success",
            "Successfully added bartender",
            "success"
          );
        })
        .catch((error) => {
          this.toastrService.show("Error", error, "danger");
        });
    }
  }
  async makeEventManager(id: string) {
    this.clearLocals();
    this.mySwal.title = "Confirm";
    this.mySwal.text = "Are you sure you want to make this user eventmanager?";
    const { isConfirmed } = await this.mySwal.fire();
    if (isConfirmed) {
      this.managerservice
        .addManager({
          event_id: this.eventId,
          user_id: id,
        })
        .then(() => {
          this.toastrService.show(
            "Success",
            "Successfully added event manager",
            "success"
          );
        })
        .catch((error) => {
          this.toastrService.show("Error", error, "danger");
        });
    }
  }
  async makeTokenDispenser(id: string) {
    this.clearLocals();
    this.mySwal.title = "Confirm";
    this.mySwal.text =
      "Are you sure you want to make this user token dispenser?";
    const { isConfirmed } = await this.mySwal.fire();
    if (isConfirmed) {
      this.tokengeneratorService
        .addTokengenerator({
          event_id: this.eventId,
          user_id: id,
        })
        .then(() => {
          this.toastrService.show(
            "Success",
            "Successfully added token dispenser",
            "success"
          );
        })
        .catch((error) => {
          this.toastrService.show("Error", error, "danger");
        });
    }
  }
  deleteFromEvent(id: string) {
    this.eventService
      .deactivateEventUser(this.eventId, id)
      .then(() => {
        this.toastrService.show(
          "Success",
          "Successfully deactivated user",
          "success"
        );
      })
      .catch((error) => {
        this.toastrService.show("Error", error, "danger");
      });
  }

  newQRCode(userId: string) {
    if (this.user.email == "" || !this.user.email) {
      this.toastrService.show(
        "Error",
        "The QR code for accounts without e-mailaddress can not be changed",
        "danger"
      );
    } else {
      return this.eventService.generateNewQRCode(this.eventId, userId);
    }
  }

  search() {
    const searchValue = this.searchValue;
    if (searchValue === "") {
      this.users = [];
    } else if (searchValue && searchValue.length > 1) {
      setTimeout(() => {
        this.searchService
          .searchUser(this.searchValue, this.eventId)
          .then((eventusers) => {
            this.users = eventusers.hits;
          });
      });
    } else {
      this.users = [];
    }
  }

  async clickItem(user: IUser & { objectID: string }) {
    this.selectedTransactionKey = "";
    this.searchValue = user.firstName + " " + user.lastName;
    this.searchValue = "";
    const userId = user.objectID;
    this.eventService.getEventUser(this.eventId, userId).subscribe((user) => {
      console.log(user);
      if (user && user.user) {
        this.user = user;
        let data = [];
        this.eventService
          .getTransactions(this.eventId, user.key)
          .subscribe((transactions) => {
            data = [];
            transactions.forEach((transaction) => {
              console.log(transaction);
              data.push({
                transactionId: transaction.key,
                timestamp: formatDate(
                  transaction.timestamp.toDate(),
                  "dd/MM/yyyy HH:mm",
                  "en-US"
                ),
                type: transaction.type,
                description:
                  transaction.description == "TRANSACTION_AT_BAR"
                    ? "Bar transactie"
                    : transaction.description == "SWIPE"
                    ? "Swipe"
                    : transaction.description,
                amount: (
                  Math.round(
                    (transaction.amount + Number.EPSILON) *
                      (transaction.fromUser?.uid == this.user.user_id ? -1 : 1)
                  ) / 100
                ).toLocaleString("be"),
                order: transaction.order,
                relatedUserName: this.getUserName(transaction),
              });
            });
            this.source.load(data);
          });
        this.userFound = true;
      } else if (user && !user.user_id) {
        this.userFound = false;
        this.addUser(this.eventId, userId);
        return true;
      }
    });
  }

  getUserName(transaction: IEventTransaction) {
    console.log(this.userId);
    if (transaction.description == "SWIPE") {
      if (transaction.fromUser?.uid == this.user.user_id) {
        // This is away from the current user
        return transaction.toUser?.name + "(" + transaction.toUser?.email + ")";
      } else {
        // This is incoming for the current user
        return (
          transaction.fromUser?.name + "(" + transaction.fromUser?.email + ")"
        );
      }
    }
    return "";
  }

  removeCategoryFromUser(categoryId: string) {
    this.eventService
      .removeCategoryFromUser(this.eventId, this.user.key, categoryId)
      .then((result) => {
        this.toastrService.show(
          "Success",
          "Successfully removed category from user",
          "success"
        );
      });
  }

  async addUserToCategory() {
    this.clearLocals();
    const categories = {};
    this.cachedCategories.forEach((category) => {
      categories[category];
    });
    //categories.push()
    const { value: category } = await Swal.fire({
      title: "Select category",
      input: "select",
      inputOptions: this.cachedCategories,
      inputPlaceholder: "Select a category",
      showCancelButton: true,
    });

    if (category) {
      this.eventService
        .addCategoryToEventUser(this.eventId, this.user.user_id, category)
        .then(() => {
          this.toastrService.show(
            "Success",
            "Successfully added category t o user",
            "success"
          );
        });
    }
  }

  loadNext() {}

  checkedChange(id: string, checked: boolean) {
    if (checked) {
      this.selectedCategories.push(id);
    } else {
      this.selectedCategories = this.selectedCategories.filter((v) => v !== id);
    }
    this.refreshFilteredUsers();
  }

  selectUser(id: string, checked: boolean) {
    if (checked) {
      this.selectedUsers.push(id);
    } else {
      this.selectedUsers = this.selectedUsers.filter((v) => v !== id);
    }
  }

  closeUser() {
    this.userFound = false;
    this.user = null;
  }

  submitNameForm(formValue) {}

  showUserOptions(id: string) {}

  selectAll(id: string, checked: boolean) {
    this.selectedUsers = [];
    if (!checked) {
      return;
    }
    this.filteredUsers.forEach((user) => {
      this.selectedUsers.push(user.key);
    });
  }

  refreshFilteredUsers() {
    if (this.selectedCategories.length == 0) {
      this.filteredUsers = [];
      return;
    }
    this.eventService
      .getUsersForCategories(this.eventId, this.selectedCategories)
      .subscribe((eventUsers) => {
        this.filteredUsers = eventUsers.sort((a, b) => {
          if (a.user.firstName < b.user.firstName) {
            return -1;
          }
          if (b.user.firstName < a.user.firstName) {
            return 1;
          }
          return 0;
        });
      });
  }

  resetCoupons() {
    this.user.coupons = 0;
    // Make a transaction record to clear them
    if (this.user) {
      this.eventService
        .createTransaction(this.eventId, this.user.key, "reset", "Admin reset")
        .then((result) => {
          this.toastrService.show(
            "Success",
            "Successfully resetted coupons",
            "success"
          );
        });
    }
  }

  exportUsers() {
    this.exporting = true;
    this.userService.exportUsers(this.eventId).subscribe((fileName) => {
      this.storageService.getFileDownloadURL(fileName).then((url) => {
        this.exporting = false;
        this.exportUsersURL = url;
      });
    });
  }

  async importUsers(withTokens?: boolean) {
    this.clearLocals();
    if (withTokens) {
      let { isConfirmed } = await this.mySwalAmountInput.fire();
      if (isConfirmed) {
        let { isConfirmed } = await this.mySwalMessageInput.fire();
        if (isConfirmed) {
        } else {
          return;
        }
      } else {
        return;
      }
    } else {
      let { isConfirmed } = await this.mySwalMessageInput.fire();
      if (isConfirmed) {
      } else {
        return;
      }
    }

    try {
      if (this.selectedAmount > 0) {
        const { users, totalAmount } = this.importService.getUsers(
          this.selectedAmount
        );
        const totalAmountInCents = totalAmount * 100;
        this.eventService
          .getEventUser(this.eventId, this.userId)
          .pipe(take(1))
          .subscribe((eventuser) => {
            if (eventuser.coupons >= totalAmountInCents) {
              console.log(
                "ze verdwijnen",
                eventuser.coupons,
                totalAmountInCents
              );
              // FIXME: This is unsafe.
              //        We don't swipe everything in one transaction but swipe it as separate transactions.
              //        If during this process the user uses part of this money, he will be able to double spend the money.
              //        In other words, the `eventuser.coupons >= totalAmountInCents` check above is not enough
              //        because the check and the swipes are not executed atomatically within the same transaction.
              users.forEach((user) => {
                this.friendService
                  .addSwipe(
                    this.userId,
                    null,
                    this.eventId,
                    this.message,
                    user.amount
                  )
                  .then((document) => {
                    // Temp HEURO exception
                    let url;
                    if (this.eventId == "CUOQNkBXBymv8joIHGXK") {
                      url = `https://heuro.bonnen.app/event/${this.eventId}/swipe-invite/${document.id}`;
                      this.invitemailService.sendMail$heuro(
                        this.eventId,
                        user.email,
                        "Je ontving zonet HEURO's!",
                        this.message,
                        url
                      );
                    } else if (this.eventId == "LZ7ccOK7GtBgyvZVQIIC") {
                      url = `https://uliege.bonnen.app/event/${this.eventId}/swipe-invite/${document.id}`;
                      this.invitemailService.sendMail$uliege(
                        this.eventId,
                        user.email,
                        "Vous venez de recevoir du crédit!",
                        this.message,
                        url
                      );
                    } else if (this.eventId == "ZHAtsBdhpNzs1iNNAbqk") {
                      url = `https://sintjozef.bonnen.app/event/${this.eventId}/swipe-invite/${document.id}`;
                      this.invitemailService.sendMail$sintjozef(
                        this.eventId,
                        user.email,
                        "Je ontving zonet bonnen!",
                        this.message,
                        url
                      );
                    } else {
                      // Should we have swipemail records created?
                      url = `https://swipedrinks.app/event/${this.eventId}/swipe-invite/${document.id}`;
                      this.invitemailService.sendMail(
                        this.eventId,
                        user.email,
                        "Swipedrinks nodigt je uit voor een nieuw event!",
                        `${this.message}<br/><br/>Klik op deze link om jou aan te melden bij Swipedrinks en jouw gratis bonnetjes te ontvangen!<br/><br/><a href='${url}'>${url}</a>`
                      );
                    }
                    
                    this.generatedURLs.push({
                      url,
                      email: user.email,
                      amount: user.amount,
                    });
                    this.amountUploaded = -1;
                  });
                this.toastrService.show(
                  "Success",
                  "Successfully sent coupons to contacts",
                  "success"
                );
              });
            } else {
              this.toastrService.show(
                "Error",
                "You don't have enough credits to swipe tokens to these users",
                "danger"
              );
            }
          });
      } else {
        const emails = this.importService.getEmails();
        emails.forEach((email) => {
          if (this.eventId == "CUOQNkBXBymv8joIHGXK") {
            this.invitemailService
              .sendMail$heuro(
                this.eventId,
                email,
                "Heuro, de nieuwe Herzele bon!",
                this.message
              )
              .then(() => {
                this.toastrService.show(
                  "Success",
                  "Successfully invited contacts",
                  "success"
                );
              });
            this.amountUploaded = -1;
          } else if (this.eventId == "LZ7ccOK7GtBgyvZVQIIC") {
            this.invitemailService
              .sendMail$uliege(
                this.eventId,
                email,
                "This is an empty message",
                this.message
              )
              .then(() => {
                this.toastrService.show(
                  "Success",
                  "Successfully invited contacts",
                  "success"
                );
              });
            this.amountUploaded = -1;
          } else if (this.eventId == "ZHAtsBdhpNzs1iNNAbqk") {
            this.invitemailService
              .sendMail$sintjozef(
                this.eventId,
                email,
                "Sint-Jozefcollege nodigt je uit voor een nieuwe app!",
                this.message
              )
              .then(() => {
                this.toastrService.show(
                  "Success",
                  "Successfully invited contacts",
                  "success"
                );
              });
            this.amountUploaded = -1;
          } else {
            this.invitemailService
              .sendMail(
                this.eventId,
                email,
                "Swipedrinks nodigt je uit voor een nieuw event!",
                `${this.message}<br/><br/>Klik op deze link om jou aan te melden bij Swipedrinks!<br/><br/><a href='https://swipedrinks.app/event/${this.eventId}'>https://swipedrinks.app/event/${this.eventId}</a>`
              )
              .then(() => {
                this.toastrService.show(
                  "Success",
                  "Successfully invited contacts",
                  "success"
                );
              });
            this.amountUploaded = -1;
          }
        });
      }
    } finally {
      this.excelFileSelected = false;
      this.importService.clear();
    }
  }

  async sendMessageToSelectedUsers() {
    this.clearLocals();
    this.mySwalMessageInput.title = "Enter message";
    let { isConfirmed } = await this.mySwalMessageInput.fire();
    if (isConfirmed) {
      this.eventService
        .getEvent(this.eventId)
        .pipe(take(1))
        .subscribe((event) => {
          const eventName = event.name;
          this.selectedUsers.forEach((toUserId) => {
            this.notificationService
              .addNotification(this.eventId, toUserId, eventName, this.message)
              .then(() => {
                this.toastrService.show(
                  "Success",
                  "Successfully sent message to " +
                    this.selectedUsers.length +
                    " users!",
                  "success"
                );
              });
          });
        });
    }
  }

  async sendMessageToUser(toUserId: string) {
    this.clearLocals();
    this.mySwalMessageInput.title = "Enter message";
    let { isConfirmed } = await this.mySwalMessageInput.fire();
    if (isConfirmed) {
      this.eventService
        .getEvent(this.eventId)
        .pipe(take(1))
        .subscribe((event) => {
          const eventName = event.name;
          this.notificationService
            .addNotification(this.eventId, toUserId, eventName, this.message)
            .then(() => {
              this.toastrService.show(
                "Success",
                "Successfully sent message to " +
                  this.selectedUsers.length +
                  " users!",
                "success"
              );
            });
        });
    }
  }

  async sendTokensToSelectedUsers(userId?: string) {
    this.clearLocals();
    const users = userId ? [userId] : this.selectedUsers;
    this.mySwalAmountInput.title = "Enter amount";
    this.mySwalMessageInput.title = "Enter message";
    let { isConfirmed } = await this.mySwalAmountInput.fire();
    if (isConfirmed) {
      let { isConfirmed } = await this.mySwalMessageInput.fire();
      if (isConfirmed) {
        this.eventService
          .getEventUser(this.eventId, this.userId)
          .pipe(take(1))
          .subscribe((eventuser) => {
            if (eventuser.coupons >= users.length * this.selectedAmount * 100) {
              users.forEach((toUserId) => {
                this.friendService.addSwipe(
                  this.userId,
                  toUserId,
                  this.eventId,
                  this.message,
                  this.selectedAmount
                );
              });
              this.toastrService.show(
                "Success",
                "Successfully sent tokens to " + users.length + " users!",
                "success"
              );
            } else {
              this.toastrService.show(
                "Error",
                "You don't have enough credits to swipe tokens to these users",
                "danger"
              );
            }
          });
      }
    }
  }

  rowSelected(event) {
    if (
      event &&
      event.data &&
      event.data.order &&
      event.data.order.length > 0
    ) {
      this.selectedTransactionKey = event.data.transactionId;
      this.order = event.data.order;
    } else {
      this.selectedTransactionKey = "";
      this.order = [];
    }
  }

  async addCategory() {
    this.clearLocals();
    this.mySwalMessageInput.title = "Enter category";
    let { isConfirmed } = await this.mySwalMessageInput.fire();
    if (isConfirmed) {
      this.eventService
        .addEventUserCategory(this.eventId, this.message)
        .then(() => {});
    }
  }

  onUploadExcel(e) {
    this.amountUploaded = -1;
    this.excelFileSelected = true;
    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0];
      this.importService
        .importFromExcelFile(file)
        .then((amountOfParsedUsers) => {
          this.amountUploaded = amountOfParsedUsers;
        })
        .catch((error) => {
          console.log("Error", error);
          this.toastrService.show("Error", error, "danger");
        });
    }
  }

  async exportImportedUsers() {
    if (!Array.isArray(this.generatedURLs)) {
      this.toastrService.show("Error", "No URLs to export", "danger");
      return;
    }

    const schema = [
      {
        column: "Email",
        type: String,
        value: (info) => info.email,
      },
      {
        column: "Amount",
        type: Number,
        value: (info) => info.amount,
      },
      {
        column: "URL",
        type: String,
        value: (info) => info.url,
      },
    ];

    try {
      await writeXlsxFile(this.generatedURLs, {
        schema,
        fileName: `imported-users-${Date.now()}.xlsx`,
      });

      this.toastrService.show(
        "Success",
        "Successfully exported URLs to Excel",
        "success"
      );
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      this.toastrService.show("Error", "Failed to export URLs", "danger");
    }
  }
}
